"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let CreateWorksheetsFromWasteBinReadingsModal = class CreateWorksheetsFromWasteBinReadingsModal extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    readings;
    onReadings(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("readings");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    labelAlign;
    item;
    async $$load_item() {
        return this.$fn.schemaDefaults('CreateWorksheetsFromReadings', { readings: this.readings });
    }
    ux;
    b_7315092382398562_modalBindings;
    b_7789867021953041_dataSource;
    b_7527331142178322_dataSource;
    b_5074589820235598_dataSource;
    dataMembers = ['formId', 'labelAlign', 'item', 'ux', 'b_7315092382398562_modalBindings', 'b_7789867021953041_dataSource', 'b_7527331142178322_dataSource', 'b_5074589820235598_dataSource'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                formId: null,
                labelAlign: "right",
                item: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "md",
                },
                b_7789867021953041_dataSource: {
                    name: "suggest_product",
                    parameters: {
                        part_types: "service",
                    },
                },
                b_7527331142178322_dataSource: {
                    name: "suggest_company",
                    parameters: {
                        role: "partner",
                        contractors_only: true,
                    },
                },
                b_5074589820235598_dataSource: {
                    name: "suggest_company_employee",
                    parameters: {
                        company_role: "partner",
                    },
                },
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.$fn.pgettext("CreateWorksheetsFromWasteBinReadingsModal", "Create Worksheets"),
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_1900_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_closeModal_1906_getActionArgs($event) {
        return {
            result: {
                close: true,
            },
        };
    }
    async act_1040167445267876_reloadSlickgrid_1908_getActionArgs($event) {
        return {
            grid: "wasteBinReadings",
        };
    }
    async act_1040167445267876_request_1904_getActionArgs($event) {
        return {
            operation: "create_worksheets_from_waste_bin_readings",
            data: this.item,
        };
    }
    async evh_1040167445267876_submit(event, scope) {
        return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
    }
    async evh_1419464017721962_clickPreventStop(event, scope) {
        return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_1900 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_1900_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_1899 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_1900,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_1899],
        });
        const act_2248226175642056_closeModal_1902 = new core_1.actions.CloseModalAction({
            events: [],
        });
        const evh_2248226175642056_close_1901 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeModal_1902,
            event: "close",
            displayName: "closeModal",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_1901],
        });
        const act_1040167445267876_closeModal_1906 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_1040167445267876_closeModal_1906_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_1905 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_closeModal_1906,
            event: "success",
            displayName: "closeModal",
        });
        const act_1040167445267876_reloadSlickgrid_1908 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_1040167445267876_reloadSlickgrid_1908_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_1907 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_reloadSlickgrid_1908,
            event: "success",
            displayName: "reloadSlickgrid",
        });
        const act_1040167445267876_request_1904 = new core_1.actions.RequestAction({
            actionArgs: this.act_1040167445267876_request_1904_getActionArgs,
            displayName: "submit",
            events: [evh_1040167445267876_success_1905, evh_1040167445267876_success_1907],
        });
        const evh_1040167445267876_submit_1903 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_request_1904,
            event: "submit",
            displayName: "submit",
        });
        const evh_1040167445267876_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_submit_1903],
        });
        const act_1419464017721962_closeModal_1910 = new core_1.actions.CloseModalAction({
            events: [],
        });
        const evh_1419464017721962_clickPreventStop_1909 = new core_1.actions.EventHandlerImpl({
            action: act_1419464017721962_closeModal_1910,
            event: "click.prevent.stop",
            displayName: "closeModal",
        });
        const evh_1419464017721962_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1419464017721962_clickPreventStop_1909],
        });
        return {
            act_7315092382398562_closeModal_1900,
            evh_7315092382398562_close_1899,
            evh_7315092382398562_close,
            act_2248226175642056_closeModal_1902,
            evh_2248226175642056_close_1901,
            evh_2248226175642056_close,
            act_1040167445267876_closeModal_1906,
            evh_1040167445267876_success_1905,
            act_1040167445267876_reloadSlickgrid_1908,
            evh_1040167445267876_success_1907,
            act_1040167445267876_request_1904,
            evh_1040167445267876_submit_1903,
            evh_1040167445267876_submit,
            act_1419464017721962_closeModal_1910,
            evh_1419464017721962_clickPreventStop_1909,
            evh_1419464017721962_clickPreventStop,
            submit: act_1040167445267876_request_1904,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Array,
    }),
    __metadata("design:type", typeof (_a = typeof array !== "undefined" && array) === "function" ? _a : Object)
], CreateWorksheetsFromWasteBinReadingsModal.prototype, "readings", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('readings'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], CreateWorksheetsFromWasteBinReadingsModal.prototype, "onReadings", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], CreateWorksheetsFromWasteBinReadingsModal.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], CreateWorksheetsFromWasteBinReadingsModal.prototype, "onSize", null);
CreateWorksheetsFromWasteBinReadingsModal = __decorate([
    (0, vue_property_decorator_1.Component)()
], CreateWorksheetsFromWasteBinReadingsModal);
exports.default = CreateWorksheetsFromWasteBinReadingsModal;
vue_property_decorator_1.Vue.component("CreateWorksheetsFromWasteBinReadingsModal", CreateWorksheetsFromWasteBinReadingsModal);
